const viewEventQueryKey = "viewEvent"

// query key generator
export const queryKeyGenerator = {
  eventBySlug: (slug: string) => [viewEventQueryKey, slug],
  me: () => ["me"],
  viewKyc: (hostId: number) => [`admin/${hostId}/view-kyc`],
}
